

































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IProposal, IProposalListRequest } from "@/types/proposal";
import { ISelectItem } from "@/types";
import {
  IPartner,
  IPartnerCreateRequest,
  IPartnerListRequest,
} from "@/types/partner";
import { PartnerCreateRequest } from "@/models/partner";
import { IMember, IMemberListRequest } from "@/types/member";
import { ISkillListRequest } from "@/types/skill";
import {
  IOffer,
  IOfferCreateRequest,
  IOfferRequest,
  IOfferUpdateRequest,
} from "@/types/offer";
import { OfferRequest, OfferUpdateRequest } from "@/models/offer";
import { IProceed, IProceedListRequest } from "@/types/proceed";
import { proceed } from "@/store/proceed";

@Component({})
export default class extends Vue {
  @Action("offer/salesGet")
  public getOffer!: (id: number) => Promise<void>;

  @Getter("offer/single")
  public offer!: IOffer;

  @Action("offer/salesCreate")
  public create!: (params: IOfferCreateRequest) => Promise<boolean>;

  @Action("offer/salesUpdate")
  public update!: (data: {
    offer_id: number;
    params: IOfferUpdateRequest;
  }) => boolean;

  @Mutation("proposal/clear")
  public clear!: () => void;

  @Action("proposal/salesGetList")
  public getProposalList!: (params: IProposalListRequest) => Promise<void>;

  @Getter("proposal/selectItem")
  public proposalList!: ISelectItem[];

  @Getter("proposal/find")
  public findProposal!: (id: number) => IProposal;

  @Action("partner/salesGetList")
  public getPartnerList!: (params: IPartnerListRequest) => Promise<void>;

  @Action("partner/salesCreate")
  public createPartner!: (params: IPartnerCreateRequest) => Promise<boolean>;

  @Getter("partner/selectItem")
  public partnerList!: ISelectItem[];

  @Getter("partner/single")
  public partner!: IPartner;

  @Action("member/adminGetList")
  public getMemberList!: (params: IMemberListRequest) => Promise<void>;

  @Getter("member/selectItem")
  public memberList!: ISelectItem[];

  @Getter("member/find")
  public findMember!: (id: number) => IMember;

  @Action("skill/getList")
  public getSkillList!: (params: ISkillListRequest) => Promise<void>;

  @Getter("skill/selectItem")
  public skillList!: ISelectItem[];

  @Action("proceed/salesGetList")
  public getProceeds!: (params: IProceedListRequest) => Promise<void>;

  @Getter("proceed/offerProceeds")
  public offerProceeds!: IProceed[];

  @Getter("error/error")
  public getError!: (key: string) => string[];

  @Getter("error/errors")
  public getErrors!: () => string[];

  public offer_id = 0;
  public proposal_id = 0;
  public member_id = 0;
  public dialog = false;

  public params: IOfferRequest = new OfferRequest();
  public partnerParams: IPartnerCreateRequest = new PartnerCreateRequest();

  private async created() {
    this.clear();

    await Promise.all([
      this.getProceeds({ per_page: 0 }),
      this.getPartnerList({ per_page: 0 }),
      this.getMemberList({ per_page: 0 }),
      this.getSkillList({ per_page: 0 }),
    ]);

    if (this.$route.params.member_id) {
      this.member_id = Number(this.$route.params.member_id);
      await this.memberSelected(this.member_id);
      if (this.$route.query.proposal_id) {
        this.proposalSelected(Number(this.$route.query.proposal_id));
      }
    }

    if (this.$route.params.offer_id) {
      this.offer_id = Number(this.$route.params.offer_id);
      await this.getOffer(this.offer_id);
      this.params = new OfferUpdateRequest(this.offer);
    }
  }

  public async submit() {
    let result = false;

    if (this.offer_id) {
      result = await this.update({
        offer_id: this.offer.id,
        params: this.params,
      });
    } else {
      result = await this.create(this.params);
    }

    if (result) {
      this.$router.go(-1);
    }
  }

  public proposalSelected(proposal_id: number) {
    this.proposal_id = proposal_id;
    const proposal = this.findProposal(proposal_id);
    this.params.convertFromProposal(proposal);
    this.setDefaultProgress();
  }

  public async memberSelected(member_id: number) {
    this.params.member_id = member_id;
    const proposalRequest: IProposalListRequest = {
      per_page: 0,
      status: 5, // 承諾のみ
      member_id: member_id,
    };
    await this.getProposalList(proposalRequest);
    if (!this.offer_id) {
      this.setDefaultProgress();
    }
  }

  public setDefaultProgress() {
    if (!this.params.member_id) {
      return;
    }
    // proceedの内容によってデフォルト値をセットする
    this.offerProceeds.forEach((proceed) => {
      const index = this.params.progress.indexOf(proceed.name);
      if (0 <= index) {
        this.params.progress.splice(index, 1); // 既にあったらいったん除外する
      }

      if (!proceed.employment_id) {
        // 雇用形態の指定なし
        this.params.progress.push(proceed.name);
        return;
      }

      // メンバの雇用形態と一致する
      const member = this.findMember(this.params.member_id);
      if (proceed.employment_id == member.profile.employment_id) {
        this.params.progress.push(proceed.name);
        return;
      }
    });
  }

  public get rules() {
    return {
      member_id: [(v: number) => !!v || "対象のメンバーは必須です"],
      title: [
        (v: string) => !!v || "案件タイトルは必須です",
        (v: string) => v.length <= 255 || "255文字以内で入力してください",
      ],
      span_start: [],
      span_end: [
        (v: string) =>
          !v ||
          !this.params.span_start ||
          v > this.params.span_start ||
          "終了日は開始日より未来にしてください",
      ],
      reward_upper: [
        (v: number) =>
          !v ||
          typeof v === "number" ||
          0 <= v ||
          "０以上の数字を入れてください",
        (v: number) =>
          !v ||
          !this.params.reward_lower ||
          v >= this.params.reward_lower ||
          "下限以上の値にしてください",
      ],
      reward_lower: [
        (v: number) =>
          !v ||
          typeof v === "number" ||
          0 <= v ||
          "０以上の数字を入れてください",
      ],
      summary: [(v: string) => !!v || "内容は必須です"],
      partner_id: [(v: number) => !!v || "パートナーは必須です"],
    };
  }
}
